<template>
  <div class="home-big">
    <!--    <div class="header-logo">-->
    <!--      <div class="header-logo-img">-->
    <!--        <img src="./logo555.png" alt="">-->
    <!--      </div>-->
    <!-- <div class="header-logo-title">
        <p>{{'体质健康服务平台'}}</p>
        <p></p>
        <p>{{'Physical Health Service Platform'}}</p>
    </div> -->
    <!-- <div class="header-logo-p">
      <p></p>
      <p></p>
      <p>{{'客服热线 : '}}
        <span>{{'185-139-36803'}}</span>
      </p>
    </div> -->
    <!--    </div>-->
    <div class="home">
      <el-container style="height: 100%;">
        <el-header>
          <s-header></s-header>
        </el-header>
        <el-container class="show-el-container">
          <left-menu></left-menu>
          <el-main>
            <router-view></router-view>
          </el-main>
        </el-container>
      </el-container>
    </div>
    <!--    <h2 class="footer-show">-->
    <!--      <p>www.haokangyun.cn&nbsp&nbsp版权所有<span @click="toAnquan">&nbsp京ICP备2021012050号-1</span></p>-->
    <!--    </h2>-->
  </div>
</template>

<script>
import LeftMenu from 'components/menu/menu'
import SHeader from 'components/header/header'
export default {
  data () {
    return {}
  },
  components: {
    LeftMenu,
    SHeader
  },
  methods:{
    toAnquan(){
      window.open('https://beian.miit.gov.cn')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.footer-show{
  height: 6%;
  display: flex;
  flex-flow: column;
  font-size: 13px;
  vertical-align: baseline;
  font-family: Avenir,Helvetica,Arial,sans-serif;
  font-family: initial;
  y-content: center;
}
.footer-show>p{
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color:#000
}
.footer-show>p>span{
  cursor:pointer;
}
.footer-show>p>span:hover{
  color: #40a9ff;
}
.header-logo{
  user-select:none;
  height:8%;
  width: 97%;
  padding: 0px 20px 0 20px;
  box-sizing: border-box;
  margin: 0 auto;
}
.header-logo-img{
  width: 200px;
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
}
.header-logo-img>img{
  width: 100%;

}
.header-logo-title{
  float: left;
  width: auto;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-flow: column;
}
.header-logo-title>p{
  flex: 1;
  width: auto;
  display: flex;
  align-items:flex-end;
  font-size: 17px;
  font-family: emoji;
  font-weight: 600;
  overflow: hidden;
}
.header-logo-title>p:nth-of-type(1){
  font-size: 18px;
  display: flex;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  align-items:flex-end;
}
.header-logo-title>p:nth-of-type(2){
  flex: 0.3;
}
.header-logo-title>p:nth-of-type(3){
  font-weight: 600;
  font-size: 15px;
  align-items: flex-start;
}
.header-logo-p{
  float: right;
  width: auto;
  height: 100%;
  display: flex;
  flex-flow: column;
}
.header-logo-p>p:nth-of-type(2){
  flex: 0.3;
}
.header-logo-p>p{
  flex: 1;
  display: flex;
  height: 100%;
  align-items: flex-end;
  font-size: 15px;
  align-items: flex-start;
}
.header-logo-p>p>span{
  font-size: 15px;
}
.show-el-container{
  height: -webkit-calc(100% - (50px));
  background-color:#f4f4f4;
}
.home-big{
  height: 100%;

}
.home{
  height:100%;
  margin: 0 auto;
  //width: 97%;
  border-radius: 10px 10px 0 0;
  box-shadow: 0 0 2px 0px #ccc;
  transition: all .6s;
}
.home:hover{
  box-shadow: 0 0 6px 0px #ccc;
}
.el-header {
  padding: 0 20px 0 0px !important;
  color: #fff;
  height: 50px !important;
  background: #1890ff;
  border-bottom: 3px solid #1890ff;
  line-height: 50px;
  //border-radius: 10px 10px 0 0;
  z-index:999;
}

.el-aside {
  color: #333;
  height:100%;
}
.el-main {
  width:100%;
  padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue